import { Api } from '@sodamnfoolish/sjc-backend-types';
import { LAMPORTS_PER_SOL } from '@solana/web3.js';

export function getBondingCurveProgress(token: Api.Bonk.DTO.LetsBonkToken): number {
    return (Number(token.realQuote) / Number(token.totalQuoteFundRaising)) * 100;
}

export function calculateMarketCap(token: Api.Bonk.DTO.LetsBonkToken, solPriceUsd: number): number {
    return (Number(token.realQuote) / LAMPORTS_PER_SOL) * solPriceUsd;
}
